import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import toast from "react-hot-toast";
import styled from "styled-components";
import useOpenDocument from "../../../hooks/useOpenDocument";
import { useAuth } from "react-oidc-context";
import { useClientContext } from "../../../hooks/ClientContext";
import { useOpenProject } from "../hooks/useOpenProject";
import { useOpenFiledEmail } from "../../../hooks/useOpenFiledEmail";
import { openClientReportHistoryModal } from "../../../components/modals/client-report-history";
import { openDeleteConfirmation } from "../../../components/modals/confirm-delete";
import { openDocumentEditModal } from "../../../components/modals/document-edit";
import { openDocumentSignaturesDisplayModal } from "../../../components/modals/document-signatures-display";
import { DropdownMenuHeader, DropdownMenuItem } from "../../../components/utilities"
import { DocumentDeleteMessage } from "./DocumentDeleteMessage";
import { DocumentType } from "../../../types/DocumentType";
import { Dropdown } from "react-bootstrap";
import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { toNString } from "../../../helpers/guids";

const ActionColumnParent = styled.td`
    width: ${({ width }) => width}%;
    cursor: pointer;
    vertical-align: middle;
    text-align: ${props => props.textAlign ?? "left"};
`;

const ActionColumnParentToggle = React.forwardRef<HTMLDivElement>(({ ...rest }, ref) => (
    <div ref={ref} {...rest}>
        <FontAwesomeIcon icon={faEllipsis} />
    </div>
));

export const ClientDocumentsTableRowActionColumn = ({ 
    data,
    width = 2.5 
} : Readonly<{
    data: DocumentType,
    width?: number
}>) => {
    const menuId = React.useId();
    const { emails, fileName, signatures, projectId, reportId } = data;
    const { openDocument } = useOpenDocument();
    const { openProject } = useOpenProject();
    const { openPreviewModal } = useOpenFiledEmail();
    const { account } = useClientContext();
    const { user } = useAuth();

    const onDeleteDocument = () => {
        openDeleteConfirmation(
            {  
                challenge: data.fileName, 
                description: data.fileName, 
                entityId: data.documentId
            },
            { 
                title: 'Delete Document', 
                message: (<DocumentDeleteMessage document={data} />) 
            }
        ).then(
            (isDeleting: boolean) => { }
        );
    };

    const onOpenDocument = () => {
        openDocument(data.documentId, data.fileName);
    }

    const onOpenDocumentEdit = () => {
        openDocumentEditModal(data, { 
            adviserId: account.adviserId,
            divisionId: account.divisionId,
            userId: toNString(user!['profile'].sub)
        }).then();
    };

    const onOpenDocumentSignatures = () => {
        openDocumentSignaturesDisplayModal({ documentId: data.documentId }).then();
    };

    const onOpenEmail = () => {
        if (emails.length <= 0) {
            toast.error('Could not open Email. Invalid or no email attached to this Document.');
            return;
        }
        if (emails.length > 1) {
            // TODO: let the user pick what email to load/display in cases like this
            return;
        }
        openPreviewModal(emails[0].emailGraphId).then();
    };
    
    const onOpenProject = () => {
        if (!data.masterAccountId || !data.projectId) {
            toast.error('Could not open Project. Invalid Master Account or Report ID.');
            return;
        }
        openProject(data.projectId);
    };

    const onOpenReportHistory = () => {
        if (!data.masterAccountId || !data.reportId) {
            toast.error('Could not open Report History. Invalid Master Account or Report ID.');
            return;
        }
        openClientReportHistoryModal(data.masterAccountId, data.reportId);
    };

    return (
        <ActionColumnParent width={width}>
            <Dropdown className="caret-off">
                <Dropdown.Toggle id={menuId} as={ActionColumnParentToggle} />
                <Dropdown.Menu style={{ maxWidth: '14rem' }}>
                    <DropdownMenuHeader>{fileName}</DropdownMenuHeader>
                    <DropdownMenuItem icon="fas fa-file-download" onClick={onOpenDocument}>Open Document</DropdownMenuItem>
                    {projectId && (
                        <DropdownMenuItem icon="fas fa-project-diagram" onClick={onOpenProject}>Open Project</DropdownMenuItem>
                    )}
                    {reportId && (
                        <DropdownMenuItem icon="fas fa-history" onClick={onOpenReportHistory}>View Report History</DropdownMenuItem>
                    )}
                    {signatures && signatures.length > 0 && (
                        <DropdownMenuItem icon="fas fa-file-contract" onClick={onOpenDocumentSignatures}>View Signatures</DropdownMenuItem>
                    )}
                    {emails && emails.length > 0 && (
                        <DropdownMenuItem icon="fas fa-envelope-open-text" onClick={onOpenEmail}>View Original Email</DropdownMenuItem>
                    )}
                    <DropdownMenuHeader variant="danger">Danger Zone</DropdownMenuHeader>
                    <DropdownMenuItem icon="fas fa-edit" variant="danger" onClick={onOpenDocumentEdit}>Edit</DropdownMenuItem>
                    {/* <DropdownMenuItem icon="fas fa-trash" variant="danger" onClick={onDeleteDocument}>Delete</DropdownMenuItem> */}
                </Dropdown.Menu>
            </Dropdown>
        </ActionColumnParent>
    );
};



// const ClientDocumentsTableRowActionColParent = styled.td`
//     vertical-align: middle;
//     text-align: ${props => props.textAlign ?? "left"};
// `;

// const ClickableIcon = styled(FontAwesomeIcon)`
//     cursor: pointer;
//     color: ${props => props.theme.muted};

//     &:hover {
//         color: ${props => darken(props.theme.linkDarkenAmount, props.theme.muted)};
//     }
// `;

// const ClientDocumentsTableRowActionCol = ({ selectDocument }) => {
//     return (
//         <ClientDocumentsTableRowActionColParent>
//             <ClickableIcon
//                 icon="edit"
//                 size="lg"
//                 onClick={selectDocument}
//             />
//         </ClientDocumentsTableRowActionColParent>
//     );
// };

// export default ClientDocumentsTableRowActionCol;

// const ClientDocumentsTableRowActionColToggle = React.forwardRef(({ ...rest }, ref) => {
//     return (
//         <div ref={ref} {...rest}>
//             <FontAwesomeIcon icon="fa-ellipsis" />
//         </div>
//     );
// });

// export const ClientDocumentOpenActionMenuItem = ({ documentId, userReadable, openDocument }) => {

//     const onHandleClick = () => {
//         if (!userReadable || !openDocument || typeof (openDocument) !== 'function') {
//             return;
//         }
//         openDocument(documentId);
//     };

//     return (
//         <Dropdown.Item disabled={!userReadable} onClick={onHandleClick}>
//             Open Document
//         </Dropdown.Item>
//     );
// };

// export const ClientDocumentEditActionMenuItem = ({ documentId, userReadable, setSelectedRow }) => {

//     const onHandleClick = () => {
//         if (!userReadable || !setSelectedRow || typeof (setSelectedRow) !== 'function') {
//             return;
//         }
//         setSelectedRow(documentId);
//     };

//     return (
//         <Dropdown.Item disabled={!userReadable} onClick={onHandleClick}>
//             Edit
//         </Dropdown.Item>
//     );
// };

// export const ClientDocumentMarkClientVisibleActionMenuItem = ({ documentId, clientReadable, userReadable, updateClientReadable }) => {
    
//     const onHandleClick = () => {
//         if (!userReadable || !updateClientReadable || typeof (updateClientReadable) !== 'function') {
//             return;
//         }
//         updateClientReadable(documentId, !clientReadable);
//     };
    
//     return (
//         <Dropdown.Item disabled={!userReadable} onClick={onHandleClick}>
//             {clientReadable ? 'Mark as Client Unreadable' : 'Mark as Client Readable'}
//         </Dropdown.Item>
//     );
// };

// const ClientDocumentsTableRowActionCol = ({ documentId, openDocument, userReadable, clientReadable, updateClientReadable, setSelectedRow }) => {
//     const menuId = React.useId();
//     return (
//         <ClientDocumentsTableRowActionColParent>
//             <Dropdown className="caret-off">
//                 <Dropdown.Toggle id={menuId} as={ClientDocumentsTableRowActionColToggle} />
//                 <Dropdown.Menu>
//                     <ClientDocumentOpenActionMenuItem 
//                         documentId={documentId}
//                         userReadable={userReadable}
//                         openDocument={openDocument}
//                     />
//                     <Dropdown.Divider />
//                     <ClientDocumentEditActionMenuItem 
//                         documentId={documentId}
//                         userReadable={userReadable}
//                         setSelectedRow={setSelectedRow}
//                     />
//                     <ClientDocumentMarkClientVisibleActionMenuItem 
//                         documentId={documentId}
//                         clientReadable={clientReadable} 
//                         userReadable={userReadable} 
//                         updateClientReadable={updateClientReadable} 
//                     />
//                 </Dropdown.Menu>
//             </Dropdown>
//         </ClientDocumentsTableRowActionColParent>
//     );
// };

// export default ClientDocumentsTableRowActionCol;